module.exports = fox => {

    'use strict';

    const EXO_UDID = require('../../../../../../../common-components/verification-form/exo-udid')(fox);
    
    require('../../../../../../../common-components/verification-form/verification-form')(fox);
    require('../../../../../../../common-components/verification-form/verification-error')(fox);

	fox.registerWidget('Login_Wizard', {
		configure() {
			this.registerOptions('', {
                widgets: {
                    login: {
                        widget: 'Login_Wizard_LoginForm',
                        active: true
                    },
                    phoneNumberAuth: {
                        widget: 'Verification_Form',
                        template: 'login_verification_form_en',
                        active: false
                    },
                    forgotPassword: {
                        widget: 'Login_Wizard_ForgotForm',
                        active: false
                    },
                    error: {
                        widget: 'Verification_Error',
                        template: 'login_verification_form_error_en',
                        active: false
                    }
                },

                handleWom: {
                    smsSendingError: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_sending_error',
                        callback: '_handleSmsSendingApiResponse'
                    },
                    smsSendingSuccess: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_sending_success',
                        callback: '_handleSmsSendingApiResponse'
                    },
                    smsVerificationError: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_verification_error',
                        callback: '_handleSmsVerificationError'
                    },
                    smsVerificationSuccess: {
                        widget: '#phoneNumberAuth',
                        event: 'sms_verification_success',
                        callback: '_handleSmsVerificationSuccess'
                    },
                    errorTimerEnd: {
                        widget: '#error',
                        event: 'cooldown_end',
                        callback: '_handleErrorTimerEnd'
                    }
                }
            });
            
            this.registerOptions('.Widget', {
                group: 'forms',
                autoRender: true,
                embed: {
                    container: '.common-content',
                    widget: '@parent @parent'
                },
            });
			
			this.callParent('configure', arguments);
        },

        showVerificationForm(data) {
            var w = this.wom1('#phoneNumberAuth');
            
            w.setData(data);

            w._sendCode();

            //this.switchEmbeddedWidget('phoneNumberAuth');
        },

        login(data) {
            this.wom1('#login').login(data);
        },

        showError(timeLeft) {
            var widget = this.wom1('#error');

            this.switchEmbeddedWidget('error');

            return this.wait(widget, 'addedToDom', {prefix: 'verificationWizardStep_error'})
                .then(() => {
                    widget.countdown(Number(timeLeft));
                });
        },

        showForgotPasswordForm() {
            this.switchEmbeddedWidget('forgotPassword');
        },
        showLoginForm() {
            this.switchEmbeddedWidget('login');
        },

        getUDID() {
            return EXO_UDID.getShortUid();
        },

        _handleSmsSendingApiResponse(answer) {
            var w = this.wom1('#phoneNumberAuth');

            if (answer.status === true) {
                w.switchActionWidgetState('success', {cooldown: answer.response});
            } else {
                if (answer.code === 1051) {
                    this.showLoginForm();

                    return;
                }

                w.switchActionWidgetState('cooldown', {cooldown: Number(answer.reason)});
            }

            this.switchEmbeddedWidget('phoneNumberAuth');
        },

        _handleErrorTimerEnd() {
            this.switchEmbeddedWidget('login');
        },

        _handleSmsVerificationError(answer, w, alias, e) {
            if (answer.code === 1053) {
                this.showError(answer.reason);

                return;
            }
        },
        _handleSmsVerificationSuccess(answer) {
            this.login(answer.response);
        },
        

	}, 'Controller');
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/model/promo2/components/login-wizard/widget/wizard.es.js